import Swiper, {Navigation} from 'swiper'

export default function ActivitySlider () {
  const ACTIVITIES_SLIDER = document.querySelectorAll('.mtt-activities')

  if (ACTIVITIES_SLIDER.length) {
    for (let i = 0; i < ACTIVITIES_SLIDER.length; i++) {
      const ACTIVITIES_SLIDER_WRAPPER = ACTIVITIES_SLIDER[i]
      const SLIDER = new ActivitiesSlider(ACTIVITIES_SLIDER_WRAPPER)
      SLIDER.init()
    }
  }
}

class ActivitiesSlider {
  constructor (wrapper) {
    this.wrapper = wrapper
    this.slider = this.wrapper.querySelector('.swiper')
    this.PREV_BUTTON = this.wrapper.querySelector('.mtt-arrow--prev')
    this.NEXT_BUTTON = this.wrapper.querySelector('.mtt-arrow--next')

    this.init = () => {
      this.addSlider()
    }
  }

  addSlider () {
    if (this.slider) {
      this.swiper = new Swiper(this.slider, {
        slidesPerView: '1.2',
        spaceBetween: 16,
        speed: 800,
        threshold: 10,
        navigation: {
            prevEl: this.PREV_BUTTON,
            nextEl: this.NEXT_BUTTON,
        },
        breakpoints: {
            768: {
                slidesPerView: '2.1',
            },
            1280: {
                slidesPerView: '3',
            },
          1600: {
            slidesPerView: '4',
          }
        }
      })
    }
  }
}